<template>
<div class="chapter">
<div class="inner_page">
<a id="pageiii">
<h1 class="title">FOLLOWING IN THE FOOTSTEPS OF</h1>
<h1 class="title_t1">OLIVER CROMWELL</h1>
<p class="title1">A HISTORICAL GUIDE TO THE CIVIL WAR</p>
<p class="author">JAMES HOBSON</p>
<div class="img_container">
<img alt="image" src="images/Img_3_120.jpg"/>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?38c44cae